// import React from "react";
// import { logoHeader } from "../assets/images/image";

// type HeaderProps = {
//     pathname: string;
// };

// export default function Header({ pathname }: HeaderProps) {
//     const [active, setActive] = React.useState(pathname);

//     const menuItems = [
//         { id: "/", label: "Home" },
//         { id: "/contact", label: "Contact" },
//     ];

//     return (
//         <>
//             {/* Desktop Layout */}
//             <header className="hidden md:flex relative w-full items-center">
//                 <img
//                     src={logoHeader}
//                     alt="Logo"
//                     className="h-[36px] absolute left-0 top-0 cursor-pointer"
//                     onClick={() => window.location.href = '/'}
//                 />
//                 <div className="mx-auto flex space-x-[128px] mt-[8px]">
//                     {menuItems.map((item) => (
//                         <button
//                             key={item.id}
//                             onClick={() => {
//                                 setActive(item.id);
//                                 window.location.href = item.id;
//                             }}
//                             className={`relative text-[16px] leading-[normal]
//                                 ${active === item.id ? "df-color font-bold" : "text-[#484848] font-normal"}`}
//                         >
//                             {item.label}
//                             {active === item.id && (
//                                 <span className="absolute -bottom-[20px] left-1/2 transform -translate-x-1/2 w-[28.518px] h-1 rounded-[16px] bg-[#3A57FF]" />
//                             )}
//                         </button>
//                     ))}
//                 </div>
//             </header>

//             {/* Mobile Layout - Fixed on top */}
//             <header className="md:hidden relative w-full">
//                 <div className="md:hidden relative top-[50px] flex items-center justify-center w-full flex-col">
//                     <img
//                         src={logoHeader}
//                         alt="Logo"
//                         className="cursor-pointer h-[24px]"
//                         onClick={() => window.location.href = '/'}
//                     />
//                     <div className="flex mt-[24px] space-x-[64px]">
//                         {menuItems.map((item) => (
//                             <button
//                                 key={item.id}
//                                 onClick={() => {
//                                     setActive(item.id);
//                                     window.location.href = item.id;
//                                 }}
//                                 className={`relative text-[16px] leading-[normal]
//                                     ${active === item.id ? "df-color font-bold" : "text-[#484848] font-normal"}`}
//                             >
//                                 {item.label}
//                                 {active === item.id && (
//                                     <span className="absolute -bottom-[8px] left-1/2 transform -translate-x-1/2 w-[28.518px] h-1 rounded-[16px] bg-[#3A57FF]" />
//                                 )}
//                             </button>
//                         ))}
//                     </div>
//                 </div>
//             </header>
//         </>
//     );
// }


import React from "react";
import { logoHeader } from "../assets/images/image";

type HeaderProps = {
    pathname: string;
};
export default function Header({ pathname }: HeaderProps) {
    const [active, setActive] = React.useState(pathname);
    const [scrolled, setScrolled] = React.useState(false);

    React.useEffect(() => {
        const handleScroll = () => {
            if (window.scrollY > 50) {
                setScrolled(true);
            } else {
                setScrolled(false);
            }
        };

        window.addEventListener('scroll', handleScroll);
        return () => window.removeEventListener('scroll', handleScroll);
    }, []);

    const menuItems = [
        { id: "/", label: "Home" },
        { id: "/contact", label: "Contact" },
    ];

    return (
        <>
            {/* Desktop Layout */}
            <header className="hidden md:flex relative w-full flex items-center">
                <img
                    src={logoHeader}
                    alt="Logo"
                    className="h-[36px] absolute left-0 top-0 cursor-pointer"
                    onClick={() => window.location.href = '/'}
                />
                <div className="mx-auto flex space-x-[128px] mt-[8px] top-0">
                    {menuItems.map((item) => (
                        <button
                            key={item.id}
                            onClick={() => {
                                setActive(item.id)
                                window.location.href = item.id
                            }}
                            className={`relative text-[16px] leading-[normal]
                        ${active === item.id ? "df-color font-bold" : "text-[#484848] font-normal"}`}
                        >
                            {item.label}
                            {active === item.id && (
                                <span className="absolute -bottom-[20px] left-1/2 transform -translate-x-1/2 w-[28.518px] h-1 flex-shrink-0 rounded-[16px] bg-[#3A57FF]" />
                            )}
                        </button>
                    ))}
                </div>
            </header>

            {/* Mobile Layout */}
            <header className="md:hidden relative w-full">
                <div
                    className={`md:hidden fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${scrolled ? 'bg-white shadow-md py-4 backdrop-blur-md' : 'bg-white/50 py-9 backdrop-blur-none'} `}
                >
                    <div className="flex flex-col items-center">
                        <img
                            src={logoHeader}
                            alt="Logo"
                            className={`cursor-pointer transition-all duration-300 ${scrolled ? 'h-[20px]' : 'h-[24px]'}`}
                            onClick={() => window.location.href = '/'}
                        />
                        <div className={`flex mt-4 space-x-[64px] transition-all duration-300 ${scrolled ? 'scale-90' : 'scale-100'}`}>
                            {menuItems.map((item) => (
                                <button
                                    key={item.id}
                                    onClick={() => {
                                        setActive(item.id);
                                        window.location.href = item.id;
                                    }}
                                    className={`relative text-[16px] leading-[normal]
                                        ${active === item.id ? "df-color font-bold" : "text-[#484848] font-normal"}`}
                                >
                                    {item.label}
                                    {active === item.id && (
                                        <span className="absolute -bottom-[20px] left-1/2 transform -translate-x-1/2 w-[28.518px] h-1 flex-shrink-0 rounded-[16px] bg-[#3A57FF]" />
                                    )}
                                </button>
                            ))}
                        </div>
                    </div>
                </div>
                {/* Spacer to account for fixed header height */}
                <div className="h-[50px] md:hidden"></div>
            </header>
        </>
    );
}